<template>
  <Calculadora />
</template>

<script>
import Calculadora from '../components/calculadora';

export default {
  name: 'Home',

  components: {
    Calculadora,
  },
};
</script>
